import createDataContext from "./createDataContext";
import dataService from "../data/dataService";

const { companies } = dataService;

const companiesReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "set_selected_company":
      return {
        ...state,
        selectedCompany: payload,
        successMessage: "",
        errorMessage: ""
      };
    case "set_companies":
      return {
        ...state,
        companies: payload.companies,
        links: payload.links,
        total_reg: payload.total_reg,
        page_size: payload.page_size,
        page: payload.page,
        total_pages: payload.total_pages,
        errorMessage: ""
      };
    case "reset_values":
      return {
        ...state,
        errorMessage: "",
        successMessage: ""
      };
    case "add_error":
      return { ...state, errorMessage: payload, successMessage: "" };
    default:
      return state;
  }
};

const getCompanies = dispatch => async (pageReq = 1) => {
  try {
    const res = await companies.index(pageReq);
    const {
      data: { data, links, total_reg, page_size, page, total_pages }
    } = res;
    dispatch({
      type: "set_companies",
      payload: {
        companies: data,
        links,
        total_reg,
        page_size,
        page,
        total_pages
      }
    });
  } catch (err) {
    dispatch({ type: "add_error", payload: err });
    console.error(err);
  }
};

const getCompanybyID = dispatch => async id => {
  dispatch({ type: "reset_values" });
  try {
    const res = await companies.detail(id);
    const { data } = res;
    dispatch({ type: "set_selected_company", payload: data });
  } catch (err) {
    dispatch({ type: "add_error", payload: err });
    console.error(err);
  }
};

const resetValues = dispatch => () => dispatch({ type: "reset_values" });

export const { Provider, Context } = createDataContext(
  companiesReducer,
  {
    getCompanies,
    getCompanybyID,
    resetValues
  },
  {
    companies: [],
    selectedCompany: null,
    links: { next: null, previous: null },
    total_reg: 0,
    page_size: 0,
    page: 1,
    total_pages: 1,
    successMessage: "",
    errorMessage: ""
  }
);
